/**
 * Leverbanner: herformatteert de bezorgdatums in de taal/het land van de klant
 * en beheert de uitklapbare tijdlijn.
 * Aantallen dagen zijn werkdagen: zaterdag en zondag worden overgeslagen
 * (zelfde rekenwijze als snippets/delivery-banner.liquid).
 */
if (!customElements.get('delivery-banner')) {
  customElements.define(
    'delivery-banner',
    class DeliveryBanner extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.delivery-banner__date');
        this.panel = this.querySelector('.delivery-banner__popover');
        this.locale = this.dataset.locale || document.documentElement.lang || 'en';

        this.renderDates();

        if (this.button && this.panel) {
          this.onToggle = this.toggle.bind(this);
          this.onDocumentClick = this.handleDocumentClick.bind(this);
          this.onKeydown = this.handleKeydown.bind(this);
          this.button.addEventListener('click', this.onToggle);
        }
      }

      disconnectedCallback() {
        this.close();
        if (this.button) this.button.removeEventListener('click', this.onToggle);
      }

      formatDate(date) {
        try {
          return new Intl.DateTimeFormat(this.locale, { day: 'numeric', month: 'short' })
            .format(date)
            .replace(/\./g, '');
        } catch (e) {
          return date.toLocaleDateString();
        }
      }

      addDays(days) {
        const d = new Date();
        let left = Number(days || 0);
        while (left > 0) {
          d.setDate(d.getDate() + 1);
          const weekday = d.getDay();
          if (weekday !== 0 && weekday !== 6) left -= 1;
        }
        return d;
      }

      range(min, max) {
        return `${this.formatDate(this.addDays(min))} - ${this.formatDate(this.addDays(max))}`;
      }

      renderDates() {
        const d = this.dataset;
        const values = {
          today: this.formatDate(new Date()),
          lead: this.range(d.leadMin, d.leadMax),
          deliver: this.range(d.deliverMin, d.deliverMax),
        };
        this.querySelectorAll('[data-delivery-date]').forEach((el) => {
          const key = el.dataset.deliveryDate;
          if (values[key]) el.textContent = values[key];
        });
      }

      get isOpen() {
        return this.button.getAttribute('aria-expanded') === 'true';
      }

      toggle(event) {
        event.preventDefault();
        this.isOpen ? this.close() : this.open();
      }

      open() {
        this.panel.hidden = false;
        this.button.setAttribute('aria-expanded', 'true');
        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('keydown', this.onKeydown);
      }

      close() {
        if (!this.panel || !this.button) return;
        this.panel.hidden = true;
        this.button.setAttribute('aria-expanded', 'false');
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keydown', this.onKeydown);
      }

      handleDocumentClick(event) {
        if (!this.contains(event.target)) this.close();
      }

      handleKeydown(event) {
        if (event.key === 'Escape') {
          this.close();
          this.button.focus();
        }
      }
    }
  );
}
